// extracted by mini-css-extract-plugin
export var cartIcon = "_p1-0";
export var cartIconContainer = "_p1-1";